import { c as _c } from "react/compiler-runtime";
import { DemoTag } from "@components/common/demo-tag";
import { FaroCardImage } from "@components/common/faro-card/faro-card-image";
import { isGroupDemo } from "@utils/group-utils";
import defaultThumbnail from "@assets/thumbnails/groups-thumbs/group-thumbnail_default.svg";

/**
 * Top section of a group card that show the group thumbnail image.
 */
export function GroupCardTop(t0) {
  const $ = _c(9);
  const {
    group
  } = t0;
  const t1 = group.thumbnailUrl ? group.thumbnailUrl : defaultThumbnail;
  let t2;
  if ($[0] !== group.id || $[1] !== group.name || $[2] !== t1) {
    t2 = <FaroCardImage src={t1} fallbackSrc={defaultThumbnail} alt={group.name} shouldNotTranslate={true} contextType="group" contextId={group.id} />;
    $[0] = group.id;
    $[1] = group.name;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== group) {
    t3 = isGroupDemo(group) && <DemoTag sx={{
      position: "absolute",
      top: "15px",
      left: "15px"
    }} />;
    $[4] = group;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}